import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import isCustomerPageMiddleware from '@features/pages/IsCustomerPageMiddleware';
import LoginPage from '@features/loginPage/LoginPage';
import { getLayoutData } from '@features/layout/api';
import { TLocale } from '@typescript/index';
import { getDevProps } from '@components/DevToolbar/helpers/getDevProps';
type PropsType = {
  loginReferer: string;
};
const Login = ({
  loginReferer
}: PropsType) => <main id="main-content">
    <LoginPage loginReferer={loginReferer} showPanel />
  </main>;
export const getServerSideProps: GetServerSideProps = async ({
  req,
  query,
  locale
}: GetServerSidePropsContext) => {
  const allowed = isCustomerPageMiddleware(() => false);
  if (allowed) return allowed;
  return {
    props: {
      ...getDevProps('dynamic'),
      loginReferer: req.headers.referer || '',
      simpleLayout: !!query.type,
      attachFirstChildToNavigation: true,
      ...(await getLayoutData(locale as TLocale)),
      ...(await serverSideTranslations(locale as string))
    }
  };
};
export default Login;